<!--
 * @symbol_custom_string_obkoro10001: -----------------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office, All rights reserved.
 * -----------------------------------------------------------------------------------
 *
-->
<template>
  <section :id="$style.Header" :class="$style.Header">
    <a :class="$style['header-logo']" :href="iconUrl">
      <img :src="s_icon" />
    </a>
    <span :class="$style['header-title']">{{ title }}</span>
  </section>
</template>
<script>
import i18n from '@/i18n'
import { mapState } from 'vuex'
import { isEduEnvSync } from '@util/edu'
export default {
  props: ['options'],
  data() {
    return {
      title: isEduEnvSync() ? i18n.t('fdf2fe129e') : i18n.t('7f0ca0df6b'),
    }
  },
  computed: {
    ...mapState({
      s_title: state => state.HeadTitle,
      s_icon: state => state.HeadIcon,
      s_url: state => state.HeadIconUrl,
    }),
  },
  watch: {
    s_title: function (newVal) {
      this.title = newVal
    },
    s_url: {
      handler: function (value) {
        this.iconUrl = value
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.title = this.$store.state['HeadTitle']
  },
}
</script>

<style lang="scss" module>
.Header {
  position: fixed;
  width: 100%;
  top: 0;
  background: #fff;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 76.9%, 0.5);
  z-index: 99;
  .header-logo {
    position: absolute;
    top: 50%;
    left: 30px;
    transform: translateY(-50%);
  }
  .header-ti {
    line-height: 1.5;
    font-size: 16px;
  }
}
</style>
